import React from 'react';
import logo from '../../img/logo.png';

const Header = ({ user, onProfileClick, onSignOut, onHelpClick, setRequireAuth, isAdmin, onLogoClick }) => {

    return (
        <header className="bg-white shadow-md fixed top-0 left-0 right-0 z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    <div className="flex-shrink-0">
                        <img 
                            src={logo} 
                            alt="AUTSAI Logo" 
                            className="h-8 w-auto cursor-pointer"
                            onClick={onLogoClick}
                        />
                    </div>

                    <div className="flex items-center space-x-4">
                        <button
                            onClick={onHelpClick}
                            className="p-2 text-gray-600 hover:text-purple-600"
                            aria-label="Help"
                        >
                            <i className="fas fa-question-circle text-xl"></i>
                        </button>

                        {user ? (
                            <>
                                <span className="hidden sm:block text-sm text-gray-600">
                                    {user.email}
                                </span>

                                <button 
                                    onClick={onSignOut}
                                    className="p-2 text-gray-600 hover:text-red-600"
                                    aria-label="Sign Out"
                                >
                                    <i className="fas fa-sign-out-alt text-xl"></i>
                                </button>

                                <div className="relative">
                                    <img 
                                        alt="User Profile" 
                                        className="h-10 w-10 rounded-full object-cover border-2 border-purple-500 cursor-pointer hover:border-purple-600 transition-colors duration-200" 
                                        src={user?.image ? user.image : '/avatars/1.png'}
                                        onClick={onProfileClick}
                                    />
                                    <div className="absolute -bottom-1 -right-1 h-3 w-3 bg-green-500 rounded-full border-2 border-white"></div>
                                </div>
                            </>
                        ) : (
                            <button
                                onClick={() => setRequireAuth(true)}
                                className="text-purple-600 hover:text-purple-700 font-medium"
                            >
                                Sign In
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
